import React, { PureComponent } from 'react'
import { Col, Row, Panel, Button } from 'react-bootstrap'
import { permissions } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects } from '../../../util/utils'
import InputDatePicker from '../../commons/form/InputDatePicker'
import { Field } from 'redux-form'

export default class Reconditioning extends PureComponent {
  constructor () {
    super()
    this.state = {
      open: false,
      fieldsConfiguration: {
        confirmationDoneButton: null,
        confirmationDate: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  toggleComponent () {
    if (this.state.open) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ open: !this.state.open })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.dossierId) {
      if (!compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
        this.initializePermisions(this.props)
      }
      if (this.props.open) {
        this.setState({ open: true })
      }
    }
    return prevProps
  }

  componentDidUpdate () {
    // don't remove use for getsnapshot
  }

  componentDidMount () {
    this.initializePermisions(this.props)
  }

  render () {
    const {
      t, dossierId, actions: { confirmDateWithIdByStage }, dossier: { reconditioning }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.RECONDITIONING.'

    return (
      <Row className="entry-panel dossier-panel">
        <div className="header-panel" onClick={() => this.toggleComponent()}>
          <div className="name-wrapper">
            <i className="ico-i" />
            <h4>{t(`${tKey}TITLE_PANEL`)}</h4>
          </div>
          <i className={this.state.open ? 'ico-arrow-black-up' : 'ico-arrow-black-down'} />
        </div>
        <Panel expanded={this.state.open} onToggle={() => {}}>
          <Panel.Collapse>
            {
              this.state.fieldsConfiguration.confirmationDoneButton && this.state.fieldsConfiguration.confirmationDoneButton.permission === permissions.editable &&
                !reconditioning?.confirmationDate && (
                <Row>
                  <Col className="col-right">
                    <Button className='btn-save' onClick={() => confirmDateWithIdByStage(dossierId)} >
                      {t(`${tKey}PERFORM`)}
                    </Button>
                  </Col>
                </Row>
              )
            }
            {
              this.state.fieldsConfiguration.confirmationDate && this.state.fieldsConfiguration.confirmationDate.permission !== permissions.hidden && (
                <Row>
                  <Field
                    id="confirmationDate"
                    key="confirmationDate"
                    name="reconditioning.confirmationDate"
                    colSm={4}
                    controlLabel={t(`${tKey}CONFIRM_DATE`)}
                    placeholder={t(`${tKey}CONFIRM_DATE`)}
                    disabled={true}
                    component={InputDatePicker}/>
                </Row>
              )
            }
          </Panel.Collapse>
        </Panel>
      </Row>
    )
  }
}
